/* World Cup Brand Report — Landing Page Copy (EN/ES) */

var EN = {
  eyebrow: 'WORLD CUP BRAND INDEX\u2122 REPORT',
  headline: 'World Cup Winners and Losers in Brand Value',
  subtitle: 'Which national teams turned the tournament into brand growth, which lost momentum, and what commercial opportunities emerged after the World Cup.',
  cred1: '48 national teams',
  cred2: '6 dimensions',
  cred3: 'Final ranking + strategic analysis',
  formTitle: 'Download the report',
  emailLabel: 'Professional email',
  emailPlaceholder: 'name@company.com',
  nameLabel: 'Name',
  namePlaceholder: 'Your name',
  cta: 'DOWNLOAD THE REPORT',
  loading: 'Preparing your report\u2026',
  trustLine: 'Immediate access. We will only use your email to send you the report.',
  privacyLink: 'Privacy Policy',
  successTitle: 'Your report is ready',
  successMsg: 'The download should begin automatically. If it does not, use the button below.',
  downloadCta: 'DOWNLOAD THE REPORT',
  errorGeneric: 'We could not process your request. Please try again.',
  errorEmail: 'Enter a valid email address.',
  errorRate: 'Too many requests. Please try again in a few minutes.',
  errorUnavailable: 'We could not prepare the report at this time. Please try again in a few moments.',
  includesTitle: 'What the report includes',
  includesBullets: [
    'Which national teams strengthened their brands after the tournament.',
    'Which major football nations lost momentum despite their historical strength.',
    'Which digital, narrative and commercial signals explain those movements.',
    'What the tournament means for sponsors, federations, agencies and broadcasters.',
  ],
  whyTitle: 'Why it matters',
  whyBlocks: [
    { audience: 'Sponsors', text: 'Identify assets whose price does not yet reflect the attention and brand strength they generate.' },
    { audience: 'Federations', text: 'Understand how much brand value has been captured and how much remains commercially unrealised.' },
    { audience: 'Agencies', text: 'Support activations, proposals and renegotiations with a defensible data-based analysis.' },
    { audience: 'Media', text: 'Turn the tournament into a clear, relevant and citable story.' },
  ],
  methTitle: 'Built from the World Cup Brand Index\u2122',
  methDesc: 'The report analyses 48 national teams across six dimensions, combining sporting, digital, commercial and cultural signals through the proprietary methodology of Your Brand Value Sports.',
  methBadges: ['48 national teams', '6 dimensions', 'YBV Sports methodology', 'ISO 10668 principles'],
  methNote: 'Strategic and directional analysis. It does not constitute an audited financial valuation and is not affiliated with FIFA, the FIFA World Cup\u2122, any football federation or any official tournament partner.',
  finalTitle: 'Access the full report',
  finalDesc: 'Download the final analysis of the World Cup winners and losers in brand value for free.',
  finalCta: 'DOWNLOAD THE REPORT',
};

var ES = {
  eyebrow: 'INFORME WORLD CUP BRAND INDEX\u2122',
  headline: 'Ganadores y perdedores del Mundial en valor de marca',
  subtitle: 'Qu\u00E9 selecciones transformaron el torneo en crecimiento de marca, cu\u00E1les perdieron impulso y qu\u00E9 oportunidades comerciales emergen tras el Mundial.',
  cred1: '48 selecciones',
  cred2: '6 dimensiones',
  cred3: 'Ranking final + lectura estrat\u00E9gica',
  formTitle: 'Descarga el informe',
  emailLabel: 'Email profesional',
  emailPlaceholder: 'nombre@empresa.com',
  nameLabel: 'Nombre',
  namePlaceholder: 'Tu nombre',
  cta: 'DESCARGAR INFORME',
  loading: 'Preparando tu informe\u2026',
  trustLine: 'Acceso inmediato. Solo usaremos tu email para enviarte el informe.',
  privacyLink: 'Pol\u00EDtica de Privacidad',
  successTitle: 'Tu informe est\u00E1 listo',
  successMsg: 'La descarga deber\u00EDa comenzar autom\u00E1ticamente. Si no lo hace, utiliza el bot\u00F3n inferior.',
  downloadCta: 'DESCARGAR EL INFORME',
  errorGeneric: 'No hemos podido procesar tu solicitud. Int\u00E9ntalo de nuevo.',
  errorEmail: 'Introduce una direcci\u00F3n de email v\u00E1lida.',
  errorRate: 'Demasiadas solicitudes. Vuelve a intentarlo en unos minutos.',
  errorUnavailable: 'No hemos podido preparar el informe en este momento. Vuelve a intentarlo en unos minutos.',
  includesTitle: 'Qu\u00E9 incluye el informe',
  includesBullets: [
    'Qu\u00E9 selecciones salen reforzadas en marca tras el torneo.',
    'Qu\u00E9 potencias pierden impulso pese a su peso hist\u00F3rico.',
    'Qu\u00E9 se\u00F1ales digitales, narrativas y comerciales explican esos movimientos.',
    'Qu\u00E9 implicaciones deja el Mundial para sponsors, federaciones, agencias y broadcasters.',
  ],
  whyTitle: 'Por qu\u00E9 importa',
  whyBlocks: [
    { audience: 'Sponsors', text: 'Detecta activos cuyo precio todav\u00EDa no refleja la atenci\u00F3n y fortaleza de marca generadas.' },
    { audience: 'Federaciones', text: 'Identifica cu\u00E1nto valor de marca se ha capturado y cu\u00E1nto sigue sin convertirse en oportunidad comercial.' },
    { audience: 'Agencias', text: 'Fundamenta activaciones, propuestas y renegociaciones con una lectura defendible basada en datos.' },
    { audience: 'Medios', text: 'Convierte el torneo en una historia clara, relevante y citable.' },
  ],
  methTitle: 'Basado en el World Cup Brand Index\u2122',
  methDesc: 'El informe analiza 48 selecciones a trav\u00E9s de seis dimensiones y combina se\u00F1ales deportivas, digitales, comerciales y culturales mediante la metodolog\u00EDa propietaria de Your Brand Value Sports.',
  methBadges: ['48 selecciones', '6 dimensiones', 'Metodolog\u00EDa YBV Sports', 'Principios ISO 10668'],
  methNote: 'An\u00E1lisis estrat\u00E9gico y direccional. No constituye una valoraci\u00F3n financiera auditada ni est\u00E1 afiliado a FIFA, a la FIFA World Cup\u2122, a ninguna federaci\u00F3n de f\u00FAtbol ni a ning\u00FAn partner oficial del torneo.',
  finalTitle: 'Accede al informe completo',
  finalDesc: 'Descarga gratis el an\u00E1lisis final sobre los ganadores y perdedores del Mundial en valor de marca.',
  finalCta: 'DESCARGAR INFORME',
};

module.exports = { EN: EN, ES: ES };
